// @ts-strict-ignore
import {
  Component, ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef
} from '@angular/core';

import { LMFormPanelBase } from './lm-form-panel-base';
import { LMModelServiceAdapter } from '@form/model/lm-model-service-adapter';
import { LMFormPagingService } from '@form/services/lm-form-paging.service';
import { LMFileUploadService } from '@services/file-upload/lm-fileupload.service';
import { LMFormRequestService } from '@form/services/lm-form-request.service';
import { LMFormToolbarService } from '@form/services/lm-form-toolbar.service';
import { LMFormComponent } from './lm-form.component';
import { LMFormActionUtilService } from '@form/services/lm-form-action-util.service';
import { AppConstants } from '@utils/app.constants';
import { LMBusyIndicatorService } from '@services/lm-busyindicator.service';
import { Observer, Observable } from 'rxjs';
import { LMUrlInfoBuilderService } from '@services/lm-url-info-builder.service';
import { LMRefreshRequest } from '@app/components';

@Component({

  providers:   [
    LMFileUploadService,
    LMFormActionUtilService,
    LMFormRequestService,
    LMFormPagingService,
    LMFormToolbarService,
    LMModelServiceAdapter
  ],

  selector: 'lm-form-panel-independentform',
  standalone: false,
  template: `
    @if (activated) {
      <lm-form
        [formUrlInfo]="formUrlInfo"
        [formSpec]="formSpec"
        [formOptions]="{}"
        [fromDataView]="fromDataView"
        [hideLayout] = "hideLayout"
        (formRendered)="onFormRendered()"
        (contentModified)="onContentModified($event)">
      </lm-form>
    }
    `,
})

export class LMFormPanelIndependentFormComponent implements OnInit, OnDestroy, LMFormPanelBase {

  @ViewChild(forwardRef(() => LMFormComponent)) private lmFormComponent; // : LMFormComponent;

  @Input() formSpec: LMFormSpec = null;
  @Input() formOptions: LMFormOptions;
  @Input() placeHolder: ViewContainerRef;
  @Input() needsReload: boolean;
  @Input() panelDataState: LMPanelDataState;
  @Input() activated: boolean;
  @Input() panelId: string;
  @Input() hideLayout = false;

  @Input() set fromDataView(fromDataView: LMDataView) {
    this._fromDataView = fromDataView;
  }

  get fromDataView(): LMDataView {
    if (this.needsReload || (this.panelDataState === 'stale_needsReload')) {

      // -------------------------------------------------------------
      // return null fromDataView so tabs non activated tabs will
      // not load their data data.
      // -------------------------------------------------------------
      return null;
    }

    return this._fromDataView;
  }

  @Output() contentModified = new EventEmitter<any>();
  @Output() componentDisplayed = new EventEmitter<any>();
  @Output() fieldEvent = new EventEmitter<LMFieldEvent>();
  @Output() formPanelContentLoaded = new EventEmitter<any>();

  private _fromDataView: LMDataView;
  public formUrlInfo: LMFormUrlInfo;

  constructor(
    private lmBusyIndicatorService: LMBusyIndicatorService,
    private lmUrlInfoBuilderService: LMUrlInfoBuilderService,
    private elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    this.formUrlInfo = this.lmUrlInfoBuilderService.getFormUrlInfoFromFormSpec(this.formSpec);
  }

  ngOnDestroy() {
  }

  onContentModified(event: any) {
    this.contentModified.emit(event);
  }

  onFieldEvent(event) {
    this.fieldEvent.emit(event);
  }

  public getPanelHeight(): number {
    if (this.elementRef) {
      return this.elementRef.nativeElement.offsetHeight;
    }
    return 0;
  }

  public refresh(request?: LMRefreshRequest): Observable<boolean> {
    return new Observable<boolean>(observer => {
      if (this.lmFormComponent) {
        this.lmFormComponent.runRefresh(observer);
      } else {
        observer.next(true);
        observer.complete();
      }
    });
  }

  public save(callBack: Observer<boolean>, skipToast?: boolean) {
    if (this.lmFormComponent && this.isDirty()) {
      this.lmFormComponent.runSaveAction(AppConstants.STANDARD_SAVE, callBack, skipToast);
    } else {
      callBack.next(true);
      callBack.complete();
    }
  }

  public isDirty(): boolean {
    return this.lmFormComponent ? this.lmFormComponent.isModified() : false;
  }

  saveCompositeComponentState(): void {
    // noop
  }

  clearCompositeComponentState(): void {
    // noop
  }

  onFormRendered() {
    this.lmBusyIndicatorService.hideBusyIndicator();
  }
}
